module.exports = __webpack_public_path__ + "static/media/lisa-win.d805d54e.png";